module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "The_Pleasures_of_Tea"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("       The Pleasures of Tea       ")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This book has been written in praise of tea, which for many millions of people throughout the world is the drink they enjoy most. Many words have been written and spoken about tea and you will find some of the most noteworthy in the pages that follow. Just why is tea such an enjoyable beverage? Surely it is because it fulfils our various needs: it refreshes us when we are thirsty; warms us when we are cold and yet it can cool us if we are hot; it stimulates us if we are tired and weary, and consoles us if we feel depressed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Afternoon tea is one of the most pleasing of meals; the food can be cooked or prepared at leisure. It provides an ideal time to relax with family or friends. Visitors to Britain are disappointed if they do not have an opportunity to sample our traditional teatime fare. There are many recipes for afternoon tea and that uniquely British meal – high tea – in this book. They come from various parts of Britain and from other tea-loving and English-speaking countries too.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Tea is a very versatile commodity; it can be served in many different ways. Try some of the hot or cold punches and wine or fruit cups on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 26")]), _vm._v(" to "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" or the delicious frozen desserts that are given in the same chapter. Different nations serve tea in a variety of ways; the customs of a number of tea-producing and tea-drinking nations will be found in the chapter beginning on "), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Styles_and_Customs_Today#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 16")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is a long and fascinating history associated with Camellia sinensis, the tea bush from which the leaves are gathered to produce the tea we find loose in packets or in teabags. It is not easy in these modern days to imagine the hardships endured by the seamen who first brought tea into Britain in their slow-moving sailing ships; we would have been a less fortunate nation if they had not succeeded. The Reverend Smith, who lived during the late eighteenth and into the middle of the nineteenth century and is renowned for the succinctness of his comments on contemporary life, said of tea (and who can disagree?):")]), _vm._v(" "), _c('p', {
    staticClass: "fm-center"
  }, [_vm._v("‘Thank God for Tea"), _c('br'), _vm._v("What would the world do without Tea.’")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_5.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Tea and tea drinking have changed many habits in Britain since tea was first introduced here in 1657; it superseded ale as the usual breakfast drink and took the place of coffee as the favourite beverage. Tea added interest to the famous Pleasure Gardens of the late eighteenth and early nineteenth centuries and they may not have been so successful if tea had not been one of the attractions. Tea played an important role in the development of our pottery industry, which has become world renowned. The beautiful tea-sets produced in the past and today not only grace British tea tables but are exported to the four corners of the world.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most children learn the words:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Polly, put the kettle on, we’ll all have tea.’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How often are similar words uttered in homes throughout Britain and many other countries of the world as the inhabitants look forward to a welcoming cup of tea?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm"
  }, [_vm._v("Marguerite Patten")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_6.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cookery Notes")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("The ingredients for the recipes in this book are given in Imperial, metric and American measures. Tips for following the recipes are given on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter02#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 50")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffa0f12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_The_Pleasures_of_Tea.vue
// module id = 69
// module chunks = 0